import styled from 'styled-components';

export const MatchTimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: ${props => props.theme.fontSets.narrowRegular};
`;

export const DateWrapper = styled.div`
  font-size: 13px;
`;

export const HoursWrapper = styled.div`
    font-size: 10px;
`;



// WEBPACK FOOTER //
// ./src/components/shared/MatchTime/styles.js